var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8224_6209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    y: 0.333496,
    width: 13.3333,
    height: 13.3333,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8224_6209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81875 8.02499L9.34411 4.51352C9.48259 4.37503 9.64151 4.3081 9.82086 4.31272C10.0002 4.31735 10.1591 4.38891 10.2976 4.5274C10.4361 4.6659 10.5053 4.82482 10.5053 5.00417C10.5053 5.18351 10.4361 5.34243 10.2976 5.48092L6.31332 9.46523C6.17483 9.60371 6.01228 9.67295 5.82569 9.67295C5.6391 9.67295 5.47656 9.60371 5.33807 9.46523L3.70098 7.82814C3.5625 7.68965 3.49195 7.53073 3.48933 7.35139C3.48671 7.17204 3.55465 7.01312 3.69314 6.87463C3.83163 6.73614 3.99055 6.66689 4.1699 6.66689C4.34924 6.66689 4.50816 6.73614 4.64665 6.87463L5.81875 8.02499Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.c1fb5c3d5acda3a0e6841dee4bfbf194.svg";
export { ForwardRef as ReactComponent };